

    // @ts-nocheck

    /*
    
    HOW TO ENABLE 'SHOW IF SKIP':

    at the bottom:
        <template v-slot:bottomcntnt>
                <p v-if="showReviewsWhenSkipped && open && $store.getters['survey/stepField']([...baseFieldAddress, 'allowSkip'])" class="block text-center w-full my-10">IF SKIPPED<InlineTooltipQuestion text="The question below will only be asked if the respondent does not leave a testimonial."/></p>
                <ShareQ :key="String('childShare'+compIndex)" v-if="!childComp && showReviewsWhenSkipped && open && $store.getters['survey/stepField']([...baseFieldAddress, 'allowSkip'])" :compIndex="compIndex" :childComp="true" class="w-full pb-5 px-5" />
        </template>

    bottom of sidecntnt:
        <Checkbox class="mt-6" v-if="!childComp && $store.getters['survey/stepField']([...baseFieldAddress, 'allowSkip'])" @update="changeShowReviews" :customModelInitValue="showReviewsWhenSkipped" label="Reviews & Shares" text="Ask for Reviews and social shares when skipped" textTip="The question below will only be asked if this testimonial question is skipped, and the respondent does not leave a testimonial."/>                
    
    */





    import SelectAnswerTypeSelector from './common/SelectAnswerTypeSelector.vue'
    import StepContainer from './common/StepContainer.vue'
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'
    import Vue from 'vue'
    import RepeatingStepLogic from './common/RepeatingStepLogic'  
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import HelperMethods from './common/HelperMethods'
    import TipsSelector from './common/TipsSelector.vue'
    import RatingScaleSelector from './common/RatingScaleSelector.vue'
    import Checkbox from './common/Checkbox.vue'
    import InlineTooltipQuestion from './common/InlineTooltipQuestion.vue'
    import { createStep } from 'fblshared';

    export default Vue.extend({
        //--------
        name: 'Testimonial',
        data () {
            return {
                showReviewsWhenSkipped: false,
                shareQuestionWhenCreated: false //is there a share question present when loaded?
            }
        },
        //--------
        created (): void { 
            const showIfSkip = this.$store.getters['survey/stepField']([...this.baseFieldAddress, 'showIfSkip'])
            if (showIfSkip) {
                //Reviews/share question needs to be rendered
                this.showReviewsWhenSkipped = true

                //record what the share question looked like:
                this.shareQuestionWhenCreated = showIfSkip

            } else {
                this.showReviewsWhenSkipped = false
            }             
        },      
        //---------
        mixins: [RepeatingStepLogic, HelperMethods],
        //---------
        props: {
            compIndex: Number
        },
        //--------
        components: {
            surveystep: StepContainer,
            TextAreaButton,
            TextInputButton,
            TipsSelector,
            ContentDisplayClosed,
            RatingScaleSelector,
            SelectAnswerTypeSelector,
            Checkbox,
            ShareQ: () => import('./ShareQ.vue'),
            InlineTooltipQuestion
        },
        computed: {
             baseFieldAddress(): any[] {
                //because this question may be a 'child' question contained in the "showIfSkip" field, 
                //the base address of fields in this question should change.
                if (this.childComp) {
                    return [this.compIndex, 'showIfSkip']
                } else {
                    return [this.compIndex]
                }                
            }
        },
        methods: {
            changeShowReviews(v: boolean): void {                
                
                if (v) {
                    
                    //we need to show a share question. Was there one when loaded?
                    if (this.shareQuestionWhenCreated) {
      
                        this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                            fieldAddress: [...this.baseFieldAddress, 'showIfSkip'],
                            val: this.shareQuestionWhenCreated
                        })

                    } else {

                        this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                            fieldAddress: [...this.baseFieldAddress, 'showIfSkip'],
                            val: createStep('shareq', this.$store.getters['dash/currentLanguagePackName'].substring(0,2), this.$store.state.survey.surveySetup.ratingType)
                        })

                    } 

                } else {
                    this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                            fieldAddress: [...this.baseFieldAddress, 'showIfSkip'],
                            val: false
                        })
                }
                
                this.showReviewsWhenSkipped = v

            }
        }
        //--------
    })
